// removed by extract-text-webpack-plugin
module.exports = {"base":"ButtonLeavingClan_base--1-dCn"};


//////////////////
// WEBPACK FOOTER
// ./components/ButtonLeavingClan/ButtonLeavingClan.scss
// module id = 2377
// module chunks = 11